import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import SouthIcon from "@mui/icons-material/South";
import { FormControlLabel } from "@mui/material";
import { useParams } from "react-router-dom";

import "./tnc.css";
import PrudentialLogo from "../../assets/prudential.svg";
import WarningIcon from "../../assets/warning.svg";
import LeadsPointScore from "../../assets/leads-point-score.png";
import TickIcon from "../../assets/tick.svg";
import ApplauseIcon from "../../assets/applause.svg";

import { ConfirmButton } from "../../../../components/buttons";
import { getTncStatus, putTncStatus } from "../../network/network";

export const AgentTnc = () => {
  const params = useParams();
  const [agree, setAgree] = useState(false);
  const [alreadyAgree, setAlreadyAgree] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<React.ReactNode>(null);
  const [image, setImage] = useState<string>("");
  useEffect(() => {
    getStatus();
  }, [params.refId]);
  const msg1 = (
    <p>
      Selamat... <br /> Anda sudah menyetujui Syarat dan ketentuan dari PRULeads Priority.
    </p>
  );
  const msg2 = <p>Anda sudah pernah menyetujui Syarat dan ketentuan dari PRULeads Priority</p>;
  const getStatus = () => {
    getTncStatus(params.refId || "").then((d) => {
      setAlreadyAgree(d.isTncAccepted);
      if (d.isTncAccepted) {
        setMessage(msg2);
        setImage(TickIcon);
      }
    });
  };

  const submitStatus = () => {
    setLoading(true);
    putTncStatus(params.refId || "")
      .then((d) => {
        setAlreadyAgree(true);
        setLoading(false);
        setMessage(msg1);
        setImage(ApplauseIcon);
      })

      .finally(() => {
        setLoading(false);
      });
  };

  if (alreadyAgree) return <AfterAccept msg={message} img={image} />;

  const ToBottom = (
    <button
      className="h-fit  sticky top-4  "
      onClick={() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      }}
    >
      <div className="absolute right-0 p-1 bg-red-500  md:-mr-[70px] -mr-[10px] bg-[#ffffff80] border-[#e1e1e180] border-2">
        <SouthIcon fontSize="small" />
        <p className="text-[8px]">Scroll Kebawah</p>
      </div>
    </button>
  );
  return (
    <div className="bg-[#EEF0F8] w-full min-h-[100vh] flex justify-center items-center">
      <div className="md:w-[500px] w-[90%] py-10 relative">
        <div className="flex justify-end mb-5">
          <img src={PrudentialLogo} alt="Prudential" />
        </div>
        <div className="flex gap-2">
          <div className="bg-white">
            <h1 className="text-xl font-medium p-6">
              Syarat dan Ketentuan penggunaan fitur <b>PRULeads Priority</b> di aplikasi PRUForce
            </h1>
            <div className="bg-[#FFFDB8] p-6 flex items-center">
              <img src={WarningIcon} />
              <p className="text-xs ml-2">
                Pastikan Anda membaca dahulu (scroll sampai paling bawah) Syarat dan Ketentuan di
                bawah ini, kemudian centang “Saya setuju” dan klik tombol “Lanjutkan” untuk dapat
                menerima Leads Nasabah Baru dari Prudential.
              </p>
            </div>
            <div className="p-6 ">
              <div className=" bg-[#F5F5F5]">
                <p className="text-xs p-6">
                  Syarat dan Ketentuan Penggunaan Fitur PRULeads Priority di aplikasi PRUForce ini
                  (selanjutnya disebut "Syarat dan Ketentuan PRULeads Priority") merupakan
                  perjanjian yang mengatur mengenai syarat dan ketentuan serta hak dan kewajiban
                  yang berlaku dan mengikat bagi PT Prudential Life Assurance, perusahaan asuransi
                  yang telah terdaftar dan diawasi oleh Otoritas Jasa Keuangan (selanjutnya disebut
                  "Prudential Indonesia") dan Tenaga Pemasar Prudential Indonesia yang bertindak
                  selaku diri sendiri yang melakukan pendaftaran penggunaan fitur PRULeads Priority
                  di aplikasi PRUForce (selanjutnya disebut sebagai "Tenaga Pemasar").
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">Pasal 1 - Definisi</p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Sepanjang tidak ditentukan lain dalam konteks kalimatnya, kata-kata dan
                  istilah-istilah yang dituliskan dengan huruf awal kapital di dalam Syarat dan
                  Ketentuan PRULeads Priority ini memiliki arti sebagai berikut:
                  <br />
                  <br />
                  <b>"PRULeads Priority"</b> adalah salah satu fitur pada PRUforce yang memungkinkan
                  Tenaga Pemasar untuk menerima Leads yang dikirimkan oleh Prudential Indonesia
                  melalui aplikasi PRUForce.
                  <br />
                  <br />
                  <b>"Leads"</b> adalah suatu data Leads yang didapatkan oleh Prudential Indonesia
                  melalui pemasangan iklan pada platform media sosial, partner digital ataupun
                  ekosistem Prudential yang sudah mendapatkan consent berupa persetujuan penggunaan
                  data untuk dikirimkan kepada Tenaga Pemasar resmi Prudential Indonesia. Prudential
                  Indonesia adalah pemilik data leads dan memiliki kebijakan penuh terhadap data
                  tersebut.
                  <br />
                  <br />
                  <b>"Leads Aktif"</b> adalah suatu Leads yang masih tercatat berstatus aktif pada
                  sistem Prudential Indonesia. Leads menjadi berstatus aktif sejak data Leads
                  tersebut masuk ke dalam sistem Prudential Indonesia dan didistribusikan kepada
                  Tenaga Pemasar. Prudential Indonesia adalah pemilik data Leads dan memiliki
                  kebijakan penuh terhadap data tersebut.
                  <br />
                  <br />
                  <b>"Leads Expiry Date"</b> atau Tanggal Kadaluarsa Leads adalah tanggal
                  berakhirnya periode Leads Aktif.
                  <br />
                  <br />
                  <b>"SKU PRUForce"</b> atau Syarat dan Ketentuan Umum Layanan PRUForce adalah
                  syarat-syarat dan ketentuan-ketentuan yang ditetapkan oleh Prudential Indonesia
                  sehubungan dengan penggunaan aplikasi PRUForce yang telah disetujui oleh Tenaga
                  Pemasar pada saat pendaftaran aplikasi PRUForce.
                  <br />
                  <br />
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">Pasal 2 – Persyaratan</p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Layanan fitur PRULeads di aplikasi PRUForce hanya dapat digunakan oleh Tenaga
                  Pemasar yang telah memenuhi persyaratan sebagai berikut:
                  <ol className="list-[lower-alpha] px-6 pt-3">
                    <li>
                      Memiliki aplikasi PRUForce yang telah terpasang (ter-install) di perangkat
                      digital milik Tenaga Pemasar;
                    </li>
                    <li>Memiliki User ID dan Password aplikasi PRUForce yang masih aktif; dan</li>
                    <li>
                      Bersedia menggunakan fitur PRULeads sesuai syarat dan ketentuan yang berlaku
                      dan telah ditetapkan oleh Prudential Indonesia.
                    </li>
                  </ol>
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">Pasal 3 – Ketentuan Penggunaan PRULeads</p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Dengan mencentang/menerima syarat dan ketentuan yang berlaku, artinya Tenaga
                  Pemasar telah mengetahui, memahami dan menyetujui hal-hal sebagai berikut:
                  <br />
                  <br />
                  Fitur PRULeads adalah sebuah layanan yang disiapkan oleh Prudential Indonesia agar
                  Tenaga Pemasar bisa mendapatkan data Leads dengan lebih cepat dan lebih mudah.
                  Data Leads yang diberikan kepada Tenaga Pemasar dapat berasal dari berbagai macam
                  sumber, seperti dari pengguna sosial media, pengguna aplikasi rekanan Prudential
                  Indonesia, maupun pengguna aplikasi yang dimiliki oleh Prudential Indonesia
                  <br />
                  <br />
                  Apabila telah mendapatkan data Leads, Tenaga Pemasar wajib untuk segera melakukan
                  tindak lanjut (follow-up) kepada Calon Nasabah, kemudian melanjutkan proses
                  penjualan seperti membuat janji temu yang dilanjutkan dengan pertemuan tatap muka
                  untuk melakukan fact-finding dan presentasi ilustrasi produk asuransi Prudential
                  Indonesia. Tenaga Pemasar wajib untuk memperbarui semua informasi yang diberikan
                  oleh Calon Nasabah menggunakan tombol “Update” pada menu PRULeads yang ada di
                  dalam aplikasi PRUForce.
                  <br />
                  <br />
                  Apabila Calon Nasabah setuju untuk membeli produk asuransi Prudential Indonesia
                  yang ditawarkan, Tenaga Pemasar wajib melanjutkan untuk membuat proposal baru
                  menggunakan data yang ada pada halaman fitur Aktivitas dan memilih menu Proposal
                  Baru untuk melanjutkan pembuatan E-SQS menggunakan aplikasi PRUForce.
                  <br />
                  <br />
                  Untuk menghindari penyalahgunaan fitur PRULeads di aplikasi PRUforce maka Tenaga
                  Pemasar wajib untuk:
                  <br />
                  <br />
                  <ol className="list-disc px-6 ">
                    <li>
                      Tidak membagikan Nama Pengguna (User ID) dan Password aplikasi PRUForce kepada
                      orang lain atau pihak manapun.
                    </li>
                    <li>
                      Tidak memberikan data Calon Nasabah yang berasal dari data Leads kepada Tenaga
                      Pemasar lainnya.
                    </li>
                  </ol>
                  <br />
                  <br />
                  Prudential Indonesia memiliki hak sepenuhnya atas fitur PRULeads dan Data Leads
                  yang diberikan kepada Tenaga Pemasar. Apabila ada Tenaga Pemasar yang melakukan
                  penyalahgunaan terhadap fitur PRULeads ataupun Data Leads, maka akan dikenakan
                  sanksi sesuai ketentuan yang berlaku di Prudential Indonesia.
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">
                    Pasal 4 – Penggunaan Fitur PRULeads di Aplikasi PRUforce
                  </p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Tenaga Pemasar wajib menerima Syarat dan Ketentuan yang berlaku sebelum mengambil
                  data Leads yang pertama kali diberikan oleh Prudential Indonesia, dengan cara
                  mencentang bagian persetujuan pada halaman Syarat dan Ketentuan. Halaman ini akan
                  tampil saat Tenaga Pemasar mengetuk tombol "Terima Peluang Jual" yang ada pada
                  halaman PRULeads di menu PRULeads Priority pada aplikasi PRUForce.
                  <br />
                  <br />
                  Tenaga Pemasar wajib mengaktifkan tombol "Terima Peluang Jual" untuk dapat
                  menerima data Leads dari Prudential Indonesia. Tenaga Pemasar diperbolehkan
                  menon-aktifkan tombol "Terima Peluang Jual" dalam kondisi tertentu saat tidak
                  memungkinkan untuk menerima data Leads, misalnya saat sedang sakit atau saat
                  berpergian/liburan dan kondisi lainnya sesuai kebutuhan Tenaga Pemasar sendiri.
                  Untuk kembali menerima data Leads, Tenaga Pemasar wajib mengaktifkan kembali
                  tombol "Terima Peluang Jual" tersebut.
                  <br />
                  <br />
                  Tenaga Pemasar bertanggung jawab untuk bertindak selaku field underwriter untuk
                  Perusahaan, bertemu secara langsung dengan calon nasabah dan calon tertanggung
                  untuk mengumpulkan informasi yang lengkap dan tepat sehubungan dengan calon
                  nasabah dan calon tertanggung mengenai risiko yang dapat timbul untuk disampaikan
                  secara lengkap kepada Perusahaan. Selanjutnya melakukan presentasi penjualan untuk
                  menjelaskan lebih lanjut mengenai manfaat dari asuransi Prudential Indonesia
                  sesuai dengan kebutuhan calon nasabah.
                  <br />
                  <br />
                  Tenaga Pemasar wajib memperbarui atau melakukan pengkinian (update) semua
                  informasi terkait proses aktivitas penjualan, dengan cara memilih menu "Update" di
                  halaman Aktivitas kemudian melakukan pembaruan/pengkinian status sesuai hasil
                  percakapan dengan Calon Nasabah. Data yang dapat diperbarui dapat berupa jadwal
                  pertemuan, hasil dari pertemuan (baik yang berhasil maupun tidak), rincian data
                  nasabah, kebutuhan produk asuransi, dan catatan lainnya yang dapat membantu
                  keberhasilan proses penjualan produk asuransi yang ditawarkan.
                  <br />
                  <br />
                  Tenaga Pemasar wajib untuk membuat ilustrasi produk asuransi menggunakan fitur
                  “Buat Proposal” pada menu PRULeads di aplikasi PRUForce berdasarkan informasi yang
                  didapatkan oleh Tenaga Pemasar saat melakukan tatap muka dengan Calon Nasabah.
                  <br />
                  <br />
                  Apabila Calon Nasabah setuju untuk membeli produk asuransi yang ditawarkan, Tenaga
                  Pemasar wajib mengajukan proposal baru menggunakan fitur E-SPAJ di PRUForce sesuai
                  dengan ketentuan yang berlaku.
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">
                    Pasal 5 – Aturan Distribusi data Leads kepada Tenaga Pemasar
                  </p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Data Leads akan didistribusikan kepada Tenaga Pemasar yang terdaftar sebagai
                  pengguna fitur PRULeads di aplikasi PRUForce dengan cara sebagai berikut:
                  <br />
                  <br />
                  <ol className="list-[lower-alpha] px-6 ">
                    <li>
                      Masing-masing Tenaga Pemasar akan diberikan kuota aktif sebanyak 3 leads atau
                      dapat dirubah sewaktu-waktu sesuai dengan kebutuhan bisnis. Apabila beberapa
                      atau semua kuota leads telah terisi, Tenaga Pemasar dapat mengosongkan
                      kuotanya kembali dengan cara melakukan update status aktivitas menjadi
                      BERHASIL MENJUAL atau GAGAL MENJUAL. PRULeads akan mengirimkan data Leads
                      kepada Tenaga Pemasar dengan kuota aktif (kuota yang masih kosong) terbanyak.
                    </li>
                    <li>
                      Apabila ada 2 atau lebih Tenaga Pemasar memiliki kuota aktif yang sama, maka
                      sistem PRULeads akan mengirimkan data Leads kepada Tenaga Pemasar yang
                      memiliki Leads Star Poin tertinggi. Leads Star Poin adalah poin yang akan
                      didapatkan oleh Tenaga Pemasar dengan cara memenuhi Service Level Agreement
                      (SLA) yang telah ditetapkan dan wajib melaporkan penggunaan fitur Aktivitas di
                      aplikasi PRUForce. Penjelasan mengenai aturan SLA dan penentuan Skor Leads
                      Star akan dijelaskan pada <b>Pasal 6</b> di bawah.
                    </li>
                    <li>
                      Apabila ada 2 atau lebih Tenaga Pemasar memiliki kuota aktif dan Leads Star
                      Poin yang sama, maka sistem PRULeads akan mengirimkan data Leads kepada Tenaga
                      Pemasar dengan produksi tertinggi dimana produksi yang dihitung hanya yang
                      bersumber dari data Leads saja.
                    </li>
                  </ol>
                  <br />
                  <br />
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">
                    Pasal 6 – Aturan Service Level Agreement & Skor PRULeads
                  </p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Sebagai salah satu komitmen Prudential Indonesia untuk memberikan layanan terbaik
                  untuk Calon Nasabah, diberlakukan aturan Service Level Agreement (SLA) untuk
                  Tenaga Pemasar. Tujuannya untuk memastikan setiap data Leads yang diberikan dapat
                  segera ditindak lanjuti, sehingga Calon Nasabah akan merasakan pengalaman yang
                  baik karena dapat lebih cepat dihubungi oleh Tenaga Pemasar yang diberikan data
                  Leads.
                  <br />
                  <br />
                  Selain itu, Tenaga Pemasar juga akan mendapatkan penambahan atau pengurangan poin
                  setiap kali Tenaga Pemasar melakukan update status aktivitas atau submit proposal
                  baru dari setiap data Leads yang diberikan menggunakan fitur Aktivitas di aplikasi
                  PRUForce. Penambahan dan pengurangan poin ini dapat dilihat dan dipantau oleh
                  Tenaga Pemasar pada bagian Leads Star Poin yang tersedia pada fitur PRULeads
                  Priority di aplikasi PRUForce. Sebagai modal awal, Prudential Indonesia memberikan
                  10 Leads Star Poin kepada Tenaga Pemasar yang baru bergabung dengan program
                  PRULeads Priority. Jumlah Leads Star Poin yang terdapat pada setiap Tenaga Pemasar
                  akan terus berubah sesuai dengan aktivitas update status yang dilakukan pada fitur
                  PRULeads Priority.
                  <br />
                  <br />
                  Aturan yang ditetapkan Prudential Indonesia untuk SLA dan Leads Star Poin adalah
                  sebagai berikut:
                  <br />
                  <br />
                  <ol className="list-[lower-alpha] px-6 ">
                    <li>
                      Tenaga Pemasar wajib <b>mengambil data Leads</b> yang diberikan maksimal{" "}
                      <b>6 jam*</b> setelah data Leads diberikan dengan cara menekan tombol "Ambil
                      Leads" pada fitur PRULeads Priority di aplikasi PRUForce. Apabila Tenaga
                      Pemasar gagal mengambil data Leads sesuai SLA yang telah ditentukan di atas,
                      maka Leads Star Poin Tenaga Pemasar tersebut akan dikurangi sebanyak 3 poin
                      (-3). Selain itu, data Leads yang sudah diberikan kepada Tenaga Pemasar
                      tersebut akan ditarik kembali dan akan dikirimkan kepada Tenaga Pemasar
                      lainnya oleh sistem PRULeads.
                    </li>
                    <li>
                      Tenaga Pemasar wajib <b>menghubungi Calon Nasabah</b> maksimal <b>24 jam*</b>{" "}
                      setelah mendapatkan data Leads dan wajib melaporkan hasilnya pada fitur
                      PRULeads Priority di aplikasi PRUForce. Apabila Tenaga Pemasar berhasil
                      melaporkan hasilnya menggunakan fitur PRULeads Priority di aplikasi PRUForce,
                      maka Tenaga Pemasar tersebut berhak mendapatkan Leads Star Poin sebanyak 1
                      poin (+1). Tetapi apabila Tenaga Pemasar tidak melaporkan hasilnya pada batas
                      waktu yang telah ditentukan di atas, maka Leads Star Poin Tenaga Pemasar
                      tersebut akan dikurangi sebanyak 1 poin (-1). Untuk kondisi dimana pada saat
                      Tenaga Pemasar telah berhasil menghubungi Calon Nasabah tetapi kemudian Calon
                      Nasabah tidak bersedia untuk melanjutkan proses pembelian polis asuransi, maka
                      apabila Tenaga Pemasar melaporkan hasil penjualan sebagai “Gagal Menjual” pada
                      fitur PRULeads Priority akan mendapatkan tambahan Skor Leads Star sebanyak 4
                      poin (+4).
                    </li>
                    <li>
                      Setelah berhasil menghubungi Calon Nasabah, Tenaga Pemasar selanjutnya wajib{" "}
                      <b>mengatur jadwal pertemuan</b> dengan Calon Nasabah paling lambat{" "}
                      <b>3 Hari*</b> dihitung sejak data Leads diterima oleh Tenaga Pemasar. Apabila
                      Tenaga Pemasar berhasil membuat jadwal pertemuan dengan Calon Nasabah dan
                      melaporkan hasilnya menggunakan fitur PRULeads Priority di aplikasi PRUForce,
                      maka Tenaga Pemasar tersebut berhak mendapatkan tambahan Leads Star Poin
                      sebanyak 1 poin (+1). Tetapi apabila Tenaga Pemasar tidak melaporkan hasilnya
                      pada batas waktu yang telah ditentukan di atas, maka Leads Star Poin Tenaga
                      Pemasar tersebut tidak akan dikurangi.
                    </li>
                    <li>
                      Setelah mengatur jadwal pertemuan dengan Calon Nasabah, Tenaga Pemasar
                      selanjutnya wajib <b>Bertemu</b> secara tatap muka atau secara virtual (sesuai
                      dengan ketentuan yang berlaku) dengan Calon Nasabah dengan tujuan melakukan{" "}
                      <i>fact-find</i> atau presentasi ilustrasi produk asuransi Prudential
                      Indonesia yang sesuai dengan kebutuhan dan kemampuan finansial Calon Nasabah,
                      paling lambat <b>15 Hari</b>* dihitung sejak data Leads diterima oleh Tenaga
                      Pemasar. Apabila Tenaga Pemasar berhasil melaporkan hasilnya menggunakan fitur
                      PRULeads Priority di aplikasi PRUForce, maka Tenaga Pemasar tersebut berhak
                      mendapatkan Leads Star Poin sebanyak 2 poin (+2). Tetapi apabila Tenaga
                      Pemasar tidak melaporkan hasilnya pada batas waktu yang telah ditentukan di
                      atas, maka Skor Leads Star Tenaga Pemasar tersebut tidak akan dikurangi.
                    </li>
                    <li>
                      Setelah bertemu dengan Calon Nasabah, Tenaga Pemasar wajib melakukan penjualan
                      produk asuransi Prudential Indonesia dengan cara melaporkan hasil penjualan,
                      yaitu “Gagal Menjual” atau “Berhasil Menjual” melalui fitur PRULeads Priority
                      di aplikasi PRUForce paling lambat <b>30 Hari</b>* dihitung sejak data Leads
                      diterima oleh Tenaga Pemasar. Apabila Tenaga Pemasar berhasil bertemu dengan
                      Calon Nasabah dan melaporkan hasilnya menggunakan fitur PRULeads Priority di
                      aplikasi PRUForce, maka Tenaga Pemasar tersebut berhak mendapatkan Skor Leads
                      Star sebanyak 5 poin (+5). Tetapi apabila Tenaga Pemasar tidak melaporkan
                      hasilnya pada batas waktu yang telah ditentukan di atas, maka Skor Leads Star
                      Tenaga Pemasar tersebut tidak akan dikurangi.
                    </li>
                  </ol>
                  <br />
                  <br />
                  Untuk lebih jelasnya, penambahan dan pengurangan poin Skor Leads Star ditunjukan
                  pada tabel di bawah ini:
                  <br />
                  <br />
                  <img src={LeadsPointScore} />
                  <br />
                  <br />
                  *) Batas waktu dihitung sejak data Leads dikirimkan kepada Tenaga Pemasar melalui
                  sistem PRULeads.
                  <br />
                  <br />
                  **) Submit Proposal wajib menggunakan akun Penerima data Leads sendiri dan wajib
                  dilakukan melalui PRULeads Priority
                  <br />
                  <br />
                  Prudential Indonesia sewaktu-waktu dapat mengubah aturan SLA yang telah ditetapkan
                  di atas, informasi mengenai aturan SLA dapat dilihat pada fitur PRULeads Priority
                  di aplikasi PRUForce.
                </p>
                <div className="border-l-4 border-[#E8192C] pl-5  ">
                  <p className="text-xs font-bold">Pasal 7 – Lain-lain</p>
                </div>
                <p className="text-xs px-6 pt-3 pb-6">
                  Syarat dan Ketentuan ini merupakan satu kesatuan dan bagian yang tidak terpisahkan
                  dari SKU PRUforce. Istilah-istilah, syarat-syarat dan ketentuan-ketentuan lain
                  terkait penggunaan PRUforce yang tidak diatur lain atau diatur secara khusus dalam
                  Syarat dan Ketentuan ini akan tetap mengacu pada istilah, syarat dan ketentuan
                  yang diatur dalam SKU PRUforce.
                  <br />
                  <br />
                  Prudential Indonesia sewaktu-waktu dapat melakukan perubahan dari syarat dan
                  ketentuan ini apabila dianggap perlu. Setiap perubahan Syarat dan Ketentuan ini
                  akan diberitahukan oleh Prudential Indonesia kepada Tenaga Pemasar sesuai
                  peraturan yang berlaku di Prudential Indonesia.
                </p>
              </div>
              <FormControlLabel
                onChange={() => setAgree(!agree)}
                className="mt-2"
                control={<Checkbox checked={agree} size="small" color="secondary" />}
                label={
                  <p className="text-sm text-[#666666]">
                    Saya setuju dengan Syarat dan Ketentuan yang berlaku
                  </p>
                }
              />
              <br />
              <br />
              <ConfirmButton disabled={!agree} onClick={submitStatus} className="w-full">
                {loading ? "Loading..." : "Lanjutkan"}
              </ConfirmButton>
            </div>
          </div>
          {ToBottom}
        </div>
      </div>
    </div>
  );
};

const AfterAccept = ({ msg, img }: { msg: React.ReactNode; img: string }) => {
  return (
    <div className="bg-[#EEF0F8] w-full min-h-[100vh] flex justify-center items-center">
      <div className="md:w-[500px] w-[90%] py-10 relative">
        <div className="flex justify-end mb-5">
          <img src={PrudentialLogo} alt="Prudential" />
        </div>
        <div className="bg-white rounded p-6 text-center flex flex-col items-center">
          <img src={img} className="w-[100px]" />
          {msg}
          <br />
          <p>
            Segera aktifkan tombol <b>“Terima Leads”</b> pada halaman PRULeads Priority, agar Anda
            bisa mulai menerima Leads Nasabah Baru dari Prudential.
          </p>
        </div>
      </div>
    </div>
  );
};
